import React from "react";
import { Modal, ModalBody } from "reactstrap";

class WrongOTPModal extends React.Component {
  render() {
    if (this.props.error == true) {
      window.setTimeout(function () {
        window.location.href = window.location.origin + "/admin/signup";
      }, 5000);
    }
    return (
      <Modal isOpen={true} className="">
        <ModalBody>
          <div className="modal-detail">
            <div className="mt-2 mb-2">
              <img src="/admin/img/otpError.svg" />
            </div>
            <div className="modal-first-content mt-2 mb-2">
              You have entered wrong OTP multiple times, we are unable to verify
              your email
            </div>
            <div>Redirecting you to signup page in 5s...</div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default WrongOTPModal;
